import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
// import { hot } from 'react-hot-loader'; // 禁用 react-hot-loader，使用 Rsbuild 内置 HMR
import { Loading, ActivityIndicator } from 'zarm';
import ErrorBoundary from 'src/components/app/ErrorBoundary';
import { KeepAlive } from 'react-activation';
import { routersTypes } from 'src/pages/routes';
import App from '../components/App/index';

const routers: routersTypes[] = [
  {
    path: '/hospital/sub/szPhysical/physicalRights',
    name: 'physical-rights',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-rights'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '体检权益',
  },
  {
    path: '/hospital/sub/szPhysical/physicalAppointment',
    name: 'physical-appointment',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-appointment'),
    auth: true,
    exact: true,
    sensitive: true,
    keepAlive: true,
    title: '体检预约',
  },
  {
    path: '/hospital/sub/szPhysical/physicalCustom',
    name: 'physical-custom',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-custom'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '客服',
  },
  {
    path: '/hospital/sub/szPhysical/physicalInstitMap',
    name: 'physical-instit-map',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-instit-map'),
    auth: true,
    exact: true,
    sensitive: true,
    keepAlive: true,
    title: '体检预约',
  },
  {
    path: '/hospital/sub/szPhysical/physicalDetail',
    name: 'physical-detail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-detail'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '套餐详情',
  },
  {
    path: '/hospital/sub/szPhysical/physicalAddItems',
    name: 'physical-add-items',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-add-items'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '加项选择',
  },
  {
    path: '/hospital/sub/szPhysical/physicalEntrance',
    name: 'physical-entrance',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-entrance'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '体检预约',
  },
  {
    path: '/hospital/sub/szPhysical/physicalPerson',
    name: 'physical-person',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-person'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '体检人信息',
  },
  {
    path: '/hospital/sub/szPhysical/physicalConfirm',
    name: 'physical-confirm',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-confirm'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '体检确认',
  },
  {
    path: '/hospital/sub/szPhysical/physicalReport',
    name: 'physical-report',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-report'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '体检报告',
  },
  {
    path: '/hospital/sub/szPhysical/physicalViewReport',
    name: 'physical-view-report',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-view-report'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '查看报告',
  },
  {
    path: '/hospital/sub/szPhysical/physicalPaySuccess',
    name: 'physical-pay-success',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-pay-success'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '支付成功',
  },
  {
    path: '/hospital/sub/szPhysical/physicalAppointmentDetail',
    name: 'physical-appointment-detail',
    component: () => import(/* webpackPrefetchPlaceHolder */ './physical-appointment-detail'),
    auth: true,
    exact: true,
    sensitive: true,
    title: '预约详情',
  },
];

export default routers;

// const Routes = () => (
//   <BrowserRouter>
//     <ErrorBoundary>
//       <App>
//         <Switch>
//           {
//             [...routers].map((item, index) => {
//               const SingleDynamicComponent = lazy(() => item.component());

//               return (
//                 <Route
//                   key={index}
//                   path={item.path}
//                   exact={item.exact || false}
//                   sensitive={item.sensitive || false}
//                   render={(props: any) => (
//                     <Suspense fallback={<Loading content={<ActivityIndicator />} />}>
//                       {
//                         item.keepAlive ? (
//                           <KeepAlive name={item.path} id={item.path}>
//                             <SingleDynamicComponent {...props} />
//                           </KeepAlive>
//                         ) : (
//                           <SingleDynamicComponent {...props} />
//                         )
//                       }
//                     </Suspense>
//                   )}
//                 />
//               );
//             })
//           }
//         </Switch>
//       </App>
//     </ErrorBoundary>
//   </BrowserRouter>
// );


// export default hot(module)(Routes);
